import template from './template.html'
import controller from './channelToggles.controller'

export default {
  restrict: 'E',
  template,
  bindings: {},
  controller,
  controllerAs: 'vm',
}
